import { TenantHostnames } from "~/api/Api";

/**
 * The hostnames of a GET /tenant/account/hostnames answer. The backend
 * keys them "tenant/hostnames"; the generated type says `tenant_hostnames`.
 */
export const getTenantHostnames = (data: object): TenantHostnames => {
  const keyed = data as {
    "tenant/hostnames"?: TenantHostnames;
    tenant_hostnames?: TenantHostnames;
  };

  return keyed["tenant/hostnames"] ?? keyed.tenant_hostnames ?? [];
};
